module.exports = __webpack_public_path__ + "static/media/office03.b5bb49c7.jpg";